import React from 'react';
import { FullStory, init } from '@fullstory/browser';
import { type User } from '@gloat/types';

export const FULLSTORY_ORG_ID = 'K723';

export default ({ user }: { user: User }) => {
  React.useEffect(() => {
    init({ orgId: FULLSTORY_ORG_ID }, () => {
      identify();
    });
  }, []);

  React.useEffect(() => {
    if (user?.numericId) {
      identify();
    }
  }, [user.numericId]);

  const identify = () => {
    const userId = user.imob
      ? `${user?.imob?.organization?.name?.toLowerCase?.()}-${user.numericId}`
      : user.numericId?.toString();
    const displayName = user.firstName || user.lastName ? `${user.firstName} ${user.lastName}` : 'Unknown';

    if (userId) {
      FullStory('setIdentity', { uid: userId, properties: { displayName } });
    }
  };

  return null;
};
